import {
  Avatar,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material"

export const InfoListItemWithNavigation = ({
  icon,
  primary,
  secondary,
  onClick,
  sx,
}) => (
  <ListItem disableGutters disablePadding sx={sx}>
    <ListItemButton onClick={onClick}>
      <ListItemAvatar>
        <Avatar color="primary" variant="rounded">
          {icon}
        </Avatar>
      </ListItemAvatar>
      <ListItemText color="primary" primary={primary} secondary={secondary} />
    </ListItemButton>
  </ListItem>
)

export const InfoListItem = ({ icon, primary, secondary, sx }) => (
  <ListItem disableGutters disablePadding sx={sx}>
    <ListItemAvatar>
      <Avatar color="primary" variant="rounded">
        {icon}
      </Avatar>
    </ListItemAvatar>
    <ListItemText color="primary" primary={primary} secondary={secondary} />
  </ListItem>
)
